import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
    updateMemberEmail,
    updateMemberEmailSuccess,
    updateMemberEmailFail
} from './workflows.action';
import { Steps, Workflows } from './workflows.model';

export interface WorkflowsRecordsState {
    listData: Workflows[];
    singleData: Workflows;
    loading: boolean;
    error: any;
    total: number;
    steps: Steps[];
    rows: any[];
}

export const initialState: WorkflowsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    steps: [],
    rows: []
};


export const WorkflowsRecordReducer = createReducer(

    initialState,
    
    //FETCH ALL
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // FETCH SINGLE
    on(fetchSingleRecordSuccess, (state, { singleData, steps }) => {
        return { ...state, singleData, steps, loading: false, error: null };
    }),

    //Update Member Email
    on(updateMemberEmail, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(updateMemberEmailSuccess, (state, { memberId, email }) => ({
        ...state,
        loading: false,
        rows: state.rows.map((r) =>
        String(r.member_id) === String(memberId)
            ? { ...r, member_email: email }
            : r
        ),
    })),

    on(updateMemberEmailFail, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    //RESET STATE
    on(resetState, () => initialState)  // Reset action handler
    
);